import ActiveStatusService from '@/services/ActiveStatusService';
import AlertingSerivce from '@/services/AlertingSerivce';
import ArchiveService from '@/services/ArchiveService';
import AuditTrailService from '@/services/AuditTrailService';
import BillingService from '@/services/BillingService';
import CommentService from '@/services/CommentService';
import DownloadService from '@/services/DownloadService';
import MailSyncService from '@/services/MailSyncService';
import NotificationService from '@/services/Notifications/NotificationService';
import NotificationTemplateService from '@/services/NotificationTemplateService';
import OnboardingService from '@/services/OnboardingService';
import PreferencesService from '@/services/PreferencesService';
import ProjectService from '@/services/ProjectService';
import PublicAPIService from '@/services/PublicAPIService';
import SearchService from '@/services/SearchService';
import SyncService from '@/services/SyncService';
import UserService from '@/services/UserService';
import VaultDataService from '@/services/VaultDataService';
import AppManagerService from '@/services/AppManagerService';

export default {
    activeStatus: ActiveStatusService,
    alerting: AlertingSerivce,
    archive: ArchiveService,
    auditTrail: AuditTrailService,
    billing: BillingService,
    comment: CommentService,
    download: DownloadService,
    mailSync: MailSyncService,
    notification: NotificationService,
    notificationTemplate: NotificationTemplateService,
    onboarding: OnboardingService,
    preferences: PreferencesService,
    project: ProjectService,
    publicAPI: PublicAPIService,
    search: SearchService,
    sync: SyncService,
    user: UserService,
    vaultData: VaultDataService,
    appManager: AppManagerService,
};